import * as React from 'react'
import { BaseIconProps } from '../../../types'

function SvgFavorite({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.022 2.368l.196.08 7 3.11a3 3 0 011.776 2.545L22 8.3v7.4a3 3 0 01-1.605 2.656l-.177.086-7 3.11a3 3 0 01-2.24.08l-.196-.08-7-3.11a3 3 0 01-1.776-2.545L2 15.7V8.3a3 3 0 011.605-2.656l.177-.086 7-3.11.196-.08a3 3 0 012.044 0zM4 8.538V15.7a1 1 0 00.478.854l.116.06L11 19.461V11.65L4 8.539zm16 0l-7 3.112v7.81l6.406-2.846a1 1 0 00.585-.784L20 15.7V8.54zm-8.293-4.305l-.113.042L5.462 7 12 9.905 18.537 7l-6.13-2.725a1 1 0 00-.7-.042z"
        fill={color}
      />
    </svg>
  )
}

export default SvgFavorite
